import { getUserDetails } from "@/api/userList";
import { todoList } from "@/api/flowable";
import { count } from "@/api/message.js";
import { setTheme, getTheme } from "@/utils/auth";
import { updateSystemStyle } from "@/utils/style";
import { opMessage } from "@/utils";
import { Notification } from "element-ui";
// import Vue from "vue"

// 创建一个假的Vue组件实例
// const vm = new Vue()

// const h = vm.$createElement
const utils = {
  namespaced: true,
  state: {
    userInfo: {}, // 用户信息
    breadList: [], //面包屑路由列表
    routerList: [], // 项目路由权限表
    subRouterList: [], // 子路由权限表
    buttonList: [], // 自定义表单用户操作权限
    findType: 1, // 自定义表单用户查看数据权限 1-本人、2-角色、3-全部
    collapse: false, // 侧边栏缩进控制开关
    todoCount: 0, //待办任务数量
    messageCount: 0, // 未读消息数量
    theme: {}, //主题
    showAllTask: false, // 展示所有数据
    fileReady: [], // 文件是否上传结束,
    isOpenAudio: localStorage.getItem("isOpenAudio") || null,
  },
  getters: {
    messageCount: (state) => state.messageCount,
    todoCount: (state) => state.todoCount,
    userInfo: (state) => state.userInfo,
    collapse: (state) => state.collapse,
    breadList: (state) => state.breadList,
    routerList: (state) => state.routerList,
    subRouterList: (state) => state.subRouterList,
    buttonList: (state) => state.buttonList,
    findType: (state) => state.findType,
    theme: (state) => state.theme,
    showAllTask: (state) => state.showAllTask,
    fileReady: (state) => state.fileReady,
    isOpenAudio: (state) => state.isOpenAudio,
  },
  mutations: {
    SET_USERINFO: (state, payload) => {
      state.userInfo = payload;
    },
    SET_BREADLIST: (state, payload) => {
      state.breadList = payload;
    },
    SET_ROUTERLIST: (state, payload) => {
      state.routerList = payload;
    },
    SET_SUBROUTERLIST: (state, payload) => {
      state.subRouterList = payload;
    },
    SET_BUTTONLIST: (state, payload) => {
      state.buttonList = payload;
    },
    SET_FINDTYPE: (state, payload) => {
      state.findType = payload;
    },
    SET_COLLAPSE: (state, payload) => {
      state.collapse = payload;
    },
    SET_TODOCOUNT: (state, payload) => {
      state.todoCount = payload;
    },
    SET_MESSAGECOUNT: (state, payload) => {
      state.messageCount = payload;
    },
    SET_THEME: (state, payload) => {
      state.theme = payload;
    },
    SET_SHOWALLTASK: (state, payload) => {
      state.showAllTask = payload;
    },
    SET_FILEREADY: (state, payload) => {
      state.fileReady = payload;
    },
    SET_ISOPENAUDIO: (state, payload) => {
      state.isOpenAudio = payload;
    },
  },
  actions: {
    init({ commit }) {
      commit("SET_MESSAGECOUNT", 0);
      commit("SET_TODOCOUNT", 0);
      commit("SET_COLLAPSE", false);
      commit("SET_BREADLIST", []);
      commit("SET_ROUTERLIST", []);
      commit("SET_SUBROUTERLIST", []);
      commit("SET_USERINFO", {});
    },
    changeTheme({ state, commit }, data) {
      if (data) {
        setTheme(data);
      }
      if (getTheme()) {
        commit("SET_THEME", getTheme());
      } else {
        // 默认主题
        let ogTheme = {
          primary1: "#4885FF",
          primary2: "#fff",
          primary3: "#fff",
          primary4: "#EEEEF0",
          primary5: "#F6F6F8",
          primary6: "#666",
          primary7: "#4885FF",
          primary8: "#fff",
          primary9: "#2782bd",
          primary10: "#EEEEF0",
          primary11: "#409EFF",
        };
        commit("SET_THEME", ogTheme);
      }
      updateSystemStyle(state.theme);
    },
    // 获取用户信息
    getUserInfo({ commit, dispatch }, data) {
      return getUserDetails().then((res) => {
        if (res && res.data.roleList && res.data.roleList.length > 0) {
          dispatch("changeTheme");
          commit("SET_USERINFO", res.data);
          // 没有角色 说明是超管
          if (!res.data.roleList[0].roleName) {
            commit("SET_SHOWALLTASK", true);
          }

          const menuTree = res.data.roleList[0].menuTree;
          commit("SET_ROUTERLIST", menuTree);

          if (menuTree && menuTree.length > 0) {
            commit("SET_SUBROUTERLIST", menuTree[0].children || []);
          }

          commit("SET_BUTTONLIST", res.data.roleList[0].buttonList);
          commit("SET_FINDTYPE", res.data.roleList[0].findType);
          if (process.env.VUE_APP_SOCKET && data && data.initSocket) {
            if (typeof WebSocket === "undefined") {
              alert("您的浏览器不支持socket");
            } else {
              if (this.socket) {
                this.socket.close();
              }
              // 实例化socket
              this.socket = new WebSocket(
                `${process.env.VUE_APP_SOCKET}/${res.data.id}`
              );
              // 监听socket错误信息
              this.socket.onerror = (err) => {
                console.log("socket错误消息", err);
              };
              // 监听socket消息
              let audioDom = null;
              audioDom = document.createElement("audio");
              audioDom.src = require("@/assets/audio/tishiyin.mp3");
              audioDom.append("body");
              audioDom.style.display = "none";
              console.log(audioDom.style);

              // let isSaveChoice = localStorage.getItem("isSaveChoice") || "no"
              // console.log("isOpenAudio", localStorage.getItem("isOpenAudio"))
              // console.log("isSaveChoice: ", isSaveChoice)
              commit("SET_ISOPENAUDIO", "yes");
              localStorage.setItem("isOpenAudio", "yes");
              localStorage.setItem("isSaveChoice", "yes");
              // if (isSaveChoice === "no") {
              //   MessageBox({
              //     title: "提示",
              //     // message: "是否打开消息声音提醒?",
              //     message: h(
              //       "div",
              //       {
              //         style: { display: "flex", flexDirection: "column", alignItems: "flex-start" }
              //       },
              //       [
              //         h(
              //           "span",
              //           {
              //             style: {
              //               marginBottom: "10px"
              //             }
              //           },
              //           "是否打开消息声音提醒?"
              //         ),
              //         h(
              //           "div",
              //           {
              //             style: { display: "flex", flexDirection: "row", alignItems: "center" }
              //           },
              //           [
              //             h("input", {
              //               style: {
              //                 marginRight: "5px"
              //               },
              //               attrs: {
              //                 type: "checkbox",
              //                 checked: isSaveChoice === "yes"
              //               },
              //               on: {
              //                 change: (event) => {
              //                   console.log("Checkbox checked:", event.target.checked)
              //                   isSaveChoice = event.target.checked ? "yes" : "no"
              //                 }
              //               }
              //             }),
              //             h(
              //               "label",
              //               {
              //                 style: {
              //                   fontSize: "13px"
              //                 }
              //               },
              //               "是否记住本次选择"
              //             )
              //           ]
              //         )
              //       ]
              //     ),
              //     showCancelButton: true
              //   })
              //     .then(() => {
              //       commit("SET_ISOPENAUDIO", "yes")
              //       localStorage.setItem("isOpenAudio", "yes")
              //       localStorage.setItem("isSaveChoice", isSaveChoice)
              //     })
              //     .catch(() => {
              //       commit("SET_ISOPENAUDIO", "no")
              //       localStorage.setItem("isOpenAudio", "no")
              //       localStorage.setItem("isSaveChoice", isSaveChoice)
              //       console.log("取消了")
              //     })
              // }

              this.socket.onmessage = (msg) => {
                if (audioDom && localStorage.getItem("isOpenAudio") == "yes") {
                  audioDom.currentTime = 0;
                  audioDom.play();
                }
                Notification({
                  title: "消息",
                  message: opMessage(msg.data),
                  duration: 3000,
                });
                count(res.data.id).then((res) => {
                  if (res) {
                    commit("SET_MESSAGECOUNT", res.data);
                  }
                });
                todoList({
                  currPage: 1,
                  pageSize: 10,
                }).then((res) => {
                  if (res) {
                    commit("SET_TODOCOUNT", res.data.total);
                  }
                });
              };
            }
          }
          return res.data;
        } else {
          localStorage.clear();
          return false;
        }
      });
    },
  },
};

export default utils;
